/* ==========================================================================
   SERPROMAQ - MÓDULO DE TALENTO, CONVOCATORIAS Y PORTAL DE POSTULACIÓN
   ========================================================================== */

import { 
  db, 
  storage, 
  collection, 
  addDoc, 
  serverTimestamp, 
  ref, 
  uploadBytes, 
  getDownloadURL 
} from './firebase-config.js';

const VACANCIES_DATA = [
  {
    id: 'mecanico',
    title: 'Técnico Electromecánico / Auxiliar Técnico',
    department: 'Mantenimiento & Operaciones Técnicas',
    badge: '3 Vacantes Abiertas',
    location: 'En Sitio / Taller Central',
    contract: 'Contrato por 1 Año + Ley',
    experience: 'Conocimiento básico o experiencia previa',
    description: 'Buscamos personas con conocimiento básico o experiencia en maquinaria industrial. Te acompañamos en tu desarrollo práctico en diagnóstico preventivo, predictivo y correctivo de montacargas eléctricos y de combustión para que crezcas profesionalmente en el sector.',
    requirements: [
      'Ganas de aprender, compromiso y motivación por la electromecánica y maquinaria.',
      'Conocimiento técnico básico en mecánica, electricidad o hidráulica.',
      'Disponibilidad para trabajar en equipo y desarrollarse dentro de la empresa.',
      'Compromiso irrenunciable con la seguridad y uso estricto de EPPs certificados.'
    ],
    perks: 'Capacitación continua en marcas líderes, asignación de vehículo taller equipado, bono por efectividad operativa y seguro SCTR integral.'
  },
  {
    id: 'operador',
    title: 'Operador de Maquinaria de Elevación',
    department: 'Operaciones Logísticas & Almacén',
    badge: '2 Vacantes Abiertas',
    location: 'Centros de Distribución / Taller',
    contract: 'Tiempo Completo + Bonos',
    experience: 'Conocimiento básico en operación de equipos',
    description: 'Buscamos personas con nociones o experiencia en el manejo de montacargas. En SERPROMAQ te acompañamos para perfeccionar tu maniobra segura, transporte vertical de carga y apilamiento en bodegas industriales.',
    requirements: [
      'Nociones básicas o experiencia en operación de montacargas (hombre sentado/parado).',
      'Sentido de responsabilidad, puntualidad y cuidado prioritario de la carga y el entorno.',
      'Licencia de conducir vigente (A-1 o equivalente).',
      'Actitud colaborativa, honestidad y orientación a la seguridad laboral.'
    ],
    perks: 'Estabilidad laboral, dotación completa de uniformes y EPPs de alta gama, primas por productividad y oportunidades de desarrollo.'
  },
  {
    id: 'comercial',
    title: 'Asesor Comercial de Maquinaria y Repuestos',
    department: 'Ventas & Soluciones para Clientes',
    badge: '1 Vacante Abierta',
    location: 'Híbrido (Oficina + Visitas a Clientes)',
    contract: 'Básico + Comisiones sin Techo',
    experience: 'Conocimiento básico comercial / Interés en el sector',
    description: 'Buscamos personas con vocación comercial y ganas de crecer en el sector industrial de maquinaria y repuestos. Te brindamos todo el soporte técnico sobre nuestro catálogo de montacargas para que asesores a nuestros clientes con confianza.',
    requirements: [
      'Excelente actitud comercial, facilidad de palabra y empatía con clientes.',
      'Interés por aprender sobre maquinaria de movimiento de carga y repuestos.',
      'Manejo básico de herramientas digitales y comunicación asertiva.',
      'Proactividad y orientación al cumplimiento de metas.'
    ],
    perks: 'Excelente esquema de comisiones sin techo, auxilio de movilidad, acompañamiento técnico continuo y plan de ascenso comercial.'
  },
  {
    id: 'supervisor',
    title: 'Auxiliar Técnico / Personal en Desarrollo',
    department: 'Área Técnica & Taller',
    badge: '2 Vacantes Abiertas',
    location: 'Taller Central / Campo',
    contract: 'Contrato a Término Fijo / Indefinido',
    experience: 'Conocimiento técnico mínimo (Con ganas de crecer)',
    description: 'Puesto ideal para quienes cuenten con una base técnica mínima y deseen crecer y hacer línea de carrera dentro de SERPROMAQ trabajando junto a nuestros técnicos e ingenieros experimentados.',
    requirements: [
      'Conocimiento técnico básico (carrera técnica en curso, egresado o afinidad mecánica).',
      'Interés y curiosidad por el mantenimiento de montacargas y maquinaria de marcas como Toyota, Hyster y Crown.',
      'Disponibilidad para apoyo en taller y aprendizaje en campo.',
      'Valores de disciplina, respeto, puntualidad y trabajo en equipo.'
    ],
    perks: 'Remuneración de ley, acompañamiento directo en el trabajo diario, ambiente seguro y oportunidad de desarrollo a técnico especialista.'
  }
];

// Correo administrativo configurable para recepción de postulaciones y CVs
export const ADMIN_RECRUITMENT_EMAIL = 'postulaciones@serpromaqsas.com';

export function initRecruitmentModule() {
  const vacancyBtns = document.querySelectorAll('.vacancy-item-btn');
  const detailPanel = document.getElementById('vacancyDetailPanel');
  const roleSelect = document.getElementById('applicantRole');

  // 1. Vacancies Tab Switching
  if (vacancyBtns.length > 0 && detailPanel) {
    vacancyBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const vacancyId = btn.getAttribute('data-vacancy-id');
        const vacancy = VACANCIES_DATA.find(v => v.id === vacancyId);

        if (!vacancy) return;

        vacancyBtns.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');

        // Render Dynamic Details with smooth animation
        detailPanel.innerHTML = `
          <div>
            <div style="display: flex; justify-content: space-between; align-items: flex-start; flex-wrap: wrap; gap: 1rem; margin-bottom: 0.45rem;">
              <div>
                <span class="vacancy-tag"><i class="fa-solid fa-briefcase"></i> ${vacancy.badge}</span>
                <h3 style="font-size: 1.45rem; color: var(--text-main); margin-top: 0.25rem; font-weight: 800;">${vacancy.title}</h3>
                <span style="color: var(--color-primary); font-weight: 700; font-size: 0.885rem;">${vacancy.department}</span>
              </div>
              <button class="btn btn-primary btn-apply-now" data-role-name="${vacancy.title}" style="padding: 0.55rem 1.35rem; font-size: 0.9rem;">
                <i class="fa-solid fa-paper-plane"></i> Postularme Ahora
              </button>
            </div>

            <p style="color: var(--text-muted); font-size: 0.9rem; line-height: 1.55; margin: 0.45rem 0;">
              ${vacancy.description}
            </p>

            <div class="vacancy-meta-grid">
              <div class="vacancy-meta-item">
                <span>Modalidad</span>
                <strong>${vacancy.location}</strong>
              </div>
              <div class="vacancy-meta-item">
                <span>Tipo de Contrato</span>
                <strong>${vacancy.contract}</strong>
              </div>
              <div class="vacancy-meta-item">
                <span>Experiencia Deseada</span>
                <strong>${vacancy.experience}</strong>
              </div>
            </div>

            <h4 style="font-size: 0.95rem; color: var(--text-main); margin-top: 0.75rem; margin-bottom: 0.45rem; font-weight: 800;">
              <i class="fa-solid fa-list-check" style="color: var(--color-primary); margin-right: 0.35rem;"></i> Requisitos Clave:
            </h4>
            <div class="vacancy-requirements-list">
              ${vacancy.requirements.map(req => `
                <div class="vacancy-req-item">
                  <i class="fa-solid fa-circle-check"></i>
                  <span>${req}</span>
                </div>
              `).join('')}
            </div>

            <div style="background: rgba(255, 122, 0, 0.08); border-left: 4px solid var(--color-primary); padding: 0.6rem 1rem; border-radius: 0 var(--radius-md) var(--radius-md) 0; margin-top: 0.5rem;">
              <strong style="color: var(--text-main); font-size: 0.85rem; display: block; margin-bottom: 0.1rem;">
                <i class="fa-solid fa-gift" style="color: var(--color-primary);"></i> Beneficios & Crecimiento SERPROMAQ:
              </strong>
              <p style="color: var(--text-muted); font-size: 0.8rem; margin: 0; line-height: 1.45;">
                ${vacancy.perks}
              </p>
            </div>
          </div>
        `;

        // Bind Apply Now click in dynamic card
        const applyBtn = detailPanel.querySelector('.btn-apply-now');
        if (applyBtn) {
          applyBtn.addEventListener('click', () => {
            const roleName = applyBtn.getAttribute('data-role-name');
            if (roleSelect) {
              roleSelect.value = roleName;
            }
            const portalSection = document.getElementById('portal-postulacion');
            if (portalSection) {
              portalSection.scrollIntoView({ behavior: 'smooth' });
            }
          });
        }
      });
    });
  }

  // 2. Interactive Brand Chips Multi-Select & Custom 'Otra Marca' field
  const brandChips = document.querySelectorAll('.brand-chip');
  const chipOther = document.getElementById('chipOtherBrand');
  const otherBrandWrapper = document.getElementById('otherBrandWrapper');
  const applicantOtherBrand = document.getElementById('applicantOtherBrand');

  brandChips.forEach(chip => {
    chip.addEventListener('click', () => {
      chip.classList.toggle('selected');

      // Si se activa o desactiva la opción 'Otro'
      if (chip === chipOther && otherBrandWrapper) {
        const isSelected = chip.classList.contains('selected');
        otherBrandWrapper.style.display = isSelected ? 'block' : 'none';
        if (isSelected && applicantOtherBrand) {
          applicantOtherBrand.focus();
        } else if (!isSelected && applicantOtherBrand) {
          applicantOtherBrand.value = '';
        }
      }
    });
  });

  // 3. Quick Apply Button listeners (from elsewhere on the page)
  const initialApplyBtns = document.querySelectorAll('.btn-apply-now');
  initialApplyBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const roleName = btn.getAttribute('data-role-name');
      if (roleSelect && roleName) {
        roleSelect.value = roleName;
      }
      const portalSection = document.getElementById('portal-postulacion');
      if (portalSection) {
        portalSection.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });

  // 4. File Upload (CV PDF / Word) Dropzone & Interactions
  const cvFileInput = document.getElementById('applicantCvFile');
  const cvDropzone = document.getElementById('cvDropzone');
  const cvPrompt = document.getElementById('cvDropzonePrompt');
  const cvFileInfo = document.getElementById('cvSelectedFileInfo');
  const cvFileName = document.getElementById('cvFileName');
  const cvFileSize = document.getElementById('cvFileSize');
  const cvTypeIcon = document.getElementById('cvTypeIcon');
  const btnRemoveCv = document.getElementById('btnRemoveCv');
  const btnToggleLink = document.getElementById('btnToggleLinkInput');
  const cvLinkWrapper = document.getElementById('cvLinkWrapper');

  let currentSelectedFile = null;

  function formatBytes(bytes, decimals = 1) {
    if (!+bytes) return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
  }

  function handleFileSelection(file) {
    if (!file) return;

    // Validación de tamaño (Máx 10 MB)
    const maxSizeBytes = 10 * 1024 * 1024;
    if (file.size > maxSizeBytes) {
      alert('El archivo seleccionado supera el límite máximo de 10 MB. Por favor elige un archivo más liviano o adjunta un enlace.');
      if (cvFileInput) cvFileInput.value = '';
      return;
    }

    // Validación de extensión
    const validExtensions = ['.pdf', '.doc', '.docx'];
    const fileNameLower = file.name.toLowerCase();
    const isValidExt = validExtensions.some(ext => fileNameLower.endsWith(ext));

    if (!isValidExt) {
      alert('Formato no compatible. Por favor sube tu currículum en formato PDF o Word (.pdf, .doc, .docx).');
      if (cvFileInput) cvFileInput.value = '';
      return;
    }

    currentSelectedFile = file;

    // Actualizar vista
    if (cvFileName) cvFileName.textContent = file.name;
    if (cvFileSize) cvFileSize.textContent = formatBytes(file.size);

    if (cvTypeIcon) {
      if (fileNameLower.endsWith('.pdf')) {
        cvTypeIcon.className = 'fa-solid fa-file-pdf cv-type-icon';
        cvTypeIcon.style.color = '#EF4444';
      } else {
        cvTypeIcon.className = 'fa-solid fa-file-word cv-type-icon';
        cvTypeIcon.style.color = '#2563EB';
      }
    }

    if (cvPrompt) cvPrompt.style.display = 'none';
    if (cvFileInfo) cvFileInfo.style.display = 'flex';
  }

  function clearFileSelection() {
    currentSelectedFile = null;
    if (cvFileInput) cvFileInput.value = '';
    if (cvPrompt) cvPrompt.style.display = 'flex';
    if (cvFileInfo) cvFileInfo.style.display = 'none';
  }

  if (cvFileInput) {
    cvFileInput.addEventListener('change', (e) => {
      const file = e.target.files?.[0];
      if (file) {
        handleFileSelection(file);
      }
    });
  }

  if (cvDropzone) {
    ['dragenter', 'dragover'].forEach(eventName => {
      cvDropzone.addEventListener(eventName, (e) => {
        e.preventDefault();
        e.stopPropagation();
        cvDropzone.classList.add('dragover');
      });
    });

    ['dragleave', 'drop'].forEach(eventName => {
      cvDropzone.addEventListener(eventName, (e) => {
        e.preventDefault();
        e.stopPropagation();
        cvDropzone.classList.remove('dragover');
      });
    });

    cvDropzone.addEventListener('drop', (e) => {
      const droppedFiles = e.dataTransfer?.files;
      if (droppedFiles && droppedFiles.length > 0) {
        handleFileSelection(droppedFiles[0]);
      }
    });
  }

  if (btnRemoveCv) {
    btnRemoveCv.addEventListener('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
      clearFileSelection();
    });
  }

  if (btnToggleLink && cvLinkWrapper) {
    btnToggleLink.addEventListener('click', () => {
      const isHidden = cvLinkWrapper.style.display === 'none';
      cvLinkWrapper.style.display = isHidden ? 'block' : 'none';
      btnToggleLink.innerHTML = isHidden 
        ? '<i class="fa-solid fa-minus"></i> Ocultar campo de enlace web'
        : '<i class="fa-solid fa-link"></i> ¿Prefieres adjuntar enlace web (LinkedIn / Drive)?';
    });
  }

  // 5. WhatsApp Application Flow
  const btnWhatsApp = document.getElementById('btnWhatsAppApply');
  if (btnWhatsApp) {
    btnWhatsApp.addEventListener('click', () => {
      const name = document.getElementById('applicantName')?.value.trim() || 'Candidato Interesado';
      const phone = document.getElementById('applicantPhone')?.value.trim() || 'No especificado';
      const role = document.getElementById('applicantRole')?.value || 'Técnico Electromecánico';
      const exp = document.getElementById('applicantExp')?.value || 'Conocimiento básico / Experiencia previa';
      const cvLink = document.getElementById('applicantCvLink')?.value.trim() || '';

      // Obtener marcas seleccionadas
      let selectedBrandsList = Array.from(document.querySelectorAll('.brand-chip.selected'))
        .map(chip => chip.getAttribute('data-brand'))
        .filter(brand => brand !== 'Otro');

      const customOtherBrand = document.getElementById('applicantOtherBrand')?.value.trim();
      if (document.getElementById('chipOtherBrand')?.classList.contains('selected') && customOtherBrand) {
        selectedBrandsList.push(`Otra (${customOtherBrand})`);
      }

      const selectedBrands = selectedBrandsList.join(', ') || 'Maquinaria general / En desarrollo';

      let cvInfoText = '';
      if (currentSelectedFile) {
        cvInfoText = `📄 *Archivo CV:* ${currentSelectedFile.name} (${formatBytes(currentSelectedFile.size)})%0A📌 *Nota:* Te adjunto mi documento de CV directamente aquí en este chat.`;
      } else if (cvLink) {
        cvInfoText = `🔗 *Enlace de CV / Portafolio:* ${encodeURIComponent(cvLink)}`;
      } else {
        cvInfoText = `📄 *CV:* Adjunto mi currículum por este chat.`;
      }

      const message = `👋 *¡Hola SERPROMAQ! Deseo postularme a su equipo de trabajo.*%0A%0A` +
        `👤 *Nombre:* ${encodeURIComponent(name)}%0A` +
        `📞 *Teléfono:* ${encodeURIComponent(phone)}%0A` +
        `💼 *Posición de Interés:* ${encodeURIComponent(role)}%0A` +
        `⏱️ *Nivel / Experiencia:* ${encodeURIComponent(exp)}%0A` +
        `🚜 *Marcas / Conocimiento:* ${encodeURIComponent(selectedBrands)}%0A` +
        `${cvInfoText}%0A%0A` +
        `_Quedo atento a la coordinación de mi entrevista y proceso de vinculación._`;

      const whatsappNumber = '573168275829';
      
      if (currentSelectedFile) {
        // Notificación amigable al usuario recordando enviar el archivo en el chat abierto
        alert(`¡Todo listo!\n\nSe abrirá WhatsApp con tus datos preparados. Recuerda enviar también tu archivo "${currentSelectedFile.name}" en la conversación que se abrirá.`);
      }
      
      window.open(`https://wa.me/${whatsappNumber}?text=${message}`, '_blank');
    });
  }

  // 6. Form Submit (Web Application Flow -> Notificación Administrativa)
  const applicantForm = document.getElementById('applicantForm');
  if (applicantForm) {
    applicantForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const submitBtn = applicantForm.querySelector('button[type="submit"]');
      const originalText = submitBtn.innerHTML;

      const name = document.getElementById('applicantName')?.value.trim();
      const phone = document.getElementById('applicantPhone')?.value.trim();
      const role = document.getElementById('applicantRole')?.value;
      const exp = document.getElementById('applicantExp')?.value;
      const cvLink = document.getElementById('applicantCvLink')?.value.trim();

      // Recopilar marcas incluyendo personalizada
      let selectedBrandsList = Array.from(document.querySelectorAll('.brand-chip.selected'))
        .map(chip => chip.getAttribute('data-brand'))
        .filter(brand => brand !== 'Otro');

      const customOtherBrand = document.getElementById('applicantOtherBrand')?.value.trim();
      if (document.getElementById('chipOtherBrand')?.classList.contains('selected') && customOtherBrand) {
        selectedBrandsList.push(`Otra (${customOtherBrand})`);
      }

      const selectedBrands = selectedBrandsList.join(', ') || 'No especificada';

      submitBtn.disabled = true;
      submitBtn.innerHTML = '<i class="fa-solid fa-spinner fa-spin"></i> Enviando postulación y currículum...';

      // Envío real con FormData al servidor PHP de Hostinger
      const formData = new FormData();
      formData.append('type', 'postulacion');
      formData.append('name', name);
      formData.append('phone', phone);
      formData.append('role', role);
      formData.append('experience', exp);
      formData.append('brands', selectedBrands);
      if (cvLink) formData.append('cv_link', cvLink);
      if (currentSelectedFile) {
        formData.append('cv_file', currentSelectedFile, currentSelectedFile.name);
      }

      // Guardar de inmediato en Firestore para que NUNCA se pierda ninguna postulación
      async function saveToFirestoreBackup() {
        try {
          let uploadedCvUrl = cvLink || '';
          if (currentSelectedFile) {
            try {
              const fileExt = currentSelectedFile.name.split('.').pop();
              const storagePath = `postulaciones/${Date.now()}_${name.replace(/[^a-zA-Z0-9]/g, '_')}.${fileExt}`;
              const storageFileRef = ref(storage, storagePath);
              const snapshot = await uploadBytes(storageFileRef, currentSelectedFile);
              uploadedCvUrl = await getDownloadURL(snapshot.ref);
            } catch (storageErr) {
              console.warn('Storage upload note:', storageErr);
            }
          }

          await addDoc(collection(db, 'postulaciones'), {
            nombre: name,
            telefono: phone,
            cargo: role,
            experiencia: exp,
            marcas: selectedBrands,
            cv_url: uploadedCvUrl,
            cv_nombre_archivo: currentSelectedFile ? currentSelectedFile.name : (cvLink ? 'Enlace Web' : 'No adjunto'),
            fecha: new Date().toLocaleString('es-CO'),
            createdAt: serverTimestamp(),
            estado: 'nueva'
          });
        } catch (dbErr) {
          console.warn('Firestore backup note:', dbErr);
        }
      }

      saveToFirestoreBackup();

      // Endpoint directo en Hostinger (compatible en Firebase y en Hostinger)
      const endpointUrl = window.location.hostname.includes('serpromaqsas.com')
        ? '/send_application.php'
        : 'https://serpromaqsas.com/send_application.php';

      fetch(endpointUrl, {
        method: 'POST',
        body: formData
      })
      .then(res => res.json())
      .then(data => {
        if (data && data.success) {
          submitBtn.innerHTML = '<i class="fa-solid fa-check"></i> ¡Postulación Enviada!';
          submitBtn.style.background = '#10B981';

          setTimeout(() => {
            const cvSummary = currentSelectedFile 
              ? `\n📁 Currículum adjunto: ${currentSelectedFile.name}` 
              : (cvLink ? `\n🔗 Enlace CV: ${cvLink}` : '');

            alert(`¡Gracias por tu postulación a SERPROMAQ!\n\nHemos recibido tu perfil profesional para el cargo de "${role}".${cvSummary}\n\nTu postulación ha sido enviada exitosamente a ${ADMIN_RECRUITMENT_EMAIL}. Nuestro equipo de Talento Humano se comunicará contigo vía WhatsApp o llamada para coordinar tu entrevista.`);
            
            applicantForm.reset();
            clearFileSelection();
            document.querySelectorAll('.brand-chip.selected').forEach(c => c.classList.remove('selected'));
            if (otherBrandWrapper) otherBrandWrapper.style.display = 'none';
            if (cvLinkWrapper) cvLinkWrapper.style.display = 'none';
            
            submitBtn.disabled = false;
            submitBtn.innerHTML = originalText;
            submitBtn.style.background = '';
          }, 400);
        } else {
          throw new Error(data?.message || 'Error al procesar la postulación.');
        }
      })
      .catch(err => {
        console.warn('Envío a Hostinger pendiente de subida de send_application.php:', err);
        // Fallback amigable
        submitBtn.innerHTML = '<i class="fa-solid fa-check"></i> ¡Postulación Registrada!';
        submitBtn.style.background = '#10B981';

        setTimeout(() => {
          alert(`¡Gracias por tu postulación a SERPROMAQ!\n\nTu información para el cargo de "${role}" ha sido registrada exitosamente en nuestra base de datos de selección.\n\nPara agilizar tu proceso, también se abrirá nuestro canal oficial de WhatsApp donde podrás interactuar directamente.`);
          
          const cleanPhone = phone.replace(/[^0-9]/g, '');
          const waText = `👋 *¡Hola SERPROMAQ! Acabo de postularme por la página web:*%0A%0A` +
            `👤 *Nombre:* ${encodeURIComponent(name)}%0A` +
            `📞 *Teléfono:* ${encodeURIComponent(phone)}%0A` +
            `💼 *Cargo:* ${encodeURIComponent(role)}%0A` +
            `⏱️ *Experiencia:* ${encodeURIComponent(exp)}%0A` +
            `🚜 *Marcas:* ${encodeURIComponent(selectedBrands)}%0A%0A` +
            `_Quedo atento a la coordinación de mi entrevista._`;

          window.open(`https://wa.me/573168275829?text=${waText}`, '_blank');

          applicantForm.reset();
          clearFileSelection();
          document.querySelectorAll('.brand-chip.selected').forEach(c => c.classList.remove('selected'));
          if (otherBrandWrapper) otherBrandWrapper.style.display = 'none';
          if (cvLinkWrapper) cvLinkWrapper.style.display = 'none';
          
          submitBtn.disabled = false;
          submitBtn.innerHTML = originalText;
          submitBtn.style.background = '';
        }, 400);
      });
    });
  }

  // 7. Inicializar Carrusel de Fotos de la Sección 2 (Talento & Convocatorias)
  initTalentoSlider();
}

/**
 * Carrusel dinámico de diapositivas para la sección de talento
 * Cambia automáticamente cada 3.2 segundos entre 6 imágenes técnicas de alta resolución
 */
export function initTalentoSlider() {
  const slides = document.querySelectorAll('.talento-slide');
  const dotBtns = document.querySelectorAll('.slider-dot-btn');
  const captionText = document.getElementById('talentoCaptionText');
  const progressBar = document.getElementById('talentoSlideProgress');
  const talentoSliderContainer = document.getElementById('talentoBackdropSlider');
  const talentoSection = document.getElementById('talento');
  const videoEl = document.getElementById('talentoVideo');
  const audioToggleBtn = document.getElementById('talentoAudioToggle');
  const audioLabel = document.getElementById('talentoAudioLabel');

  if (slides.length === 0) return;

  const captions = [
    'Equipo Técnico & Montacargas Eléctricos en Sede',
    'Logística & Móvil Taller para Soporte en Terreno',
    'Asesoría, Talento Humano & Compromiso SERPROMAQ',
    'Alistamiento Técnico & Verificación Operativa',
    'Seguridad Ocupacional, EPPs & Maquinaria de Punta',
    'Familia y Equipo de Especialistas SERPROMAQ',
    'Video Oficial: SERPROMAQ en Acción'
  ];

  let currentSlideIndex = 0;
  const TALENTO_INTERVAL = 5500; // 5.5 segundos por foto
  const VIDEO_INDEX = slides.length - 1; // Último slide es el video
  let isHovered = false;
  let isTalentoSectionVisible = false;

  // Limpiar cualquier temporizador previo global
  if (window._talentoSliderTimer) {
    clearInterval(window._talentoSliderTimer);
    window._talentoSliderTimer = null;
  }

  function setAudioState(isMuted) {
    if (!videoEl) return;
    videoEl.muted = isMuted;
    if (audioToggleBtn) {
      audioToggleBtn.classList.toggle('muted', isMuted);
      const icon = audioToggleBtn.querySelector('i');
      if (icon) {
        icon.className = isMuted ? 'fa-solid fa-volume-xmark' : 'fa-solid fa-volume-high';
      }
    }
    if (audioLabel) {
      audioLabel.textContent = isMuted ? 'Mudo' : 'Sonido ON';
    }
  }

  if (audioToggleBtn && videoEl) {
    audioToggleBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      setAudioState(!videoEl.muted);
    });
  }

  function showSlide(index) {
    if (index < 0 || index >= slides.length) return;
    currentSlideIndex = index;

    slides.forEach((slide, i) => {
      if (i === index) {
        slide.classList.add('active');
      } else {
        slide.classList.remove('active');
      }
    });

    dotBtns.forEach((dot, i) => {
      if (i === index) {
        dot.classList.add('active');
      } else {
        dot.classList.remove('active');
      }
    });

    if (captionText && captions[index]) {
      captionText.style.opacity = '0';
      captionText.style.transform = 'translateY(3px)';
      setTimeout(() => {
        captionText.textContent = captions[index];
        captionText.style.transition = 'all 0.4s ease';
        captionText.style.opacity = '1';
        captionText.style.transform = 'translateY(0)';
      }, 250);
    }

    // Comportamiento especial para el Video (Slide final)
    if (index === VIDEO_INDEX && videoEl) {
      stopSliderTimer();
      videoEl.currentTime = 0;

      // Solo reproducir si la sección talento está visible actualmente en pantalla
      if (isTalentoSectionVisible) {
        setAudioState(false);
        const playPromise = videoEl.play();
        if (playPromise !== undefined) {
          playPromise.catch(() => {
            setAudioState(true);
            videoEl.play().catch(() => {});
          });
        }
      } else {
        videoEl.pause();
      }

      // El video dura sus 50s. Al terminar vuelve a la foto 1 e inicia el ciclo
      videoEl.onended = () => {
        showSlide(0);
        startSliderTimer();
      };

      // Barra de progreso sincronizada con el tiempo real del video
      videoEl.ontimeupdate = () => {
        if (progressBar && videoEl.duration) {
          const pct = (videoEl.currentTime / videoEl.duration) * 100;
          progressBar.style.animation = 'none';
          progressBar.style.width = `${pct}%`;
        }
      };
    } else {
      // Slides normales de fotos
      if (videoEl) {
        videoEl.pause();
        videoEl.currentTime = 0;
        videoEl.ontimeupdate = null;
        videoEl.onended = null;
      }

      if (progressBar) {
        progressBar.style.width = '0%';
        progressBar.style.animation = 'none';
        void progressBar.offsetWidth;
        if (!isHovered) {
          progressBar.style.animation = `slideProgressBar ${TALENTO_INTERVAL}ms linear infinite`;
        }
      }
    }
  }

  function startSliderTimer() {
    stopSliderTimer();
    if (currentSlideIndex === VIDEO_INDEX) return; // No auto-rotar por tiempo mientras está el video

    if (progressBar && !isHovered) {
      progressBar.style.animation = `slideProgressBar ${TALENTO_INTERVAL}ms linear infinite`;
    }
    window._talentoSliderTimer = setInterval(() => {
      if (!isHovered) {
        const nextIndex = (currentSlideIndex + 1) % slides.length;
        showSlide(nextIndex);
      }
    }, TALENTO_INTERVAL);
  }

  function stopSliderTimer() {
    if (window._talentoSliderTimer) {
      clearInterval(window._talentoSliderTimer);
      window._talentoSliderTimer = null;
    }
    if (progressBar && currentSlideIndex !== VIDEO_INDEX) {
      progressBar.style.animationPlayState = 'paused';
    }
  }

  // Pausar rotación al pasar el mouse por encima
  const hoverTargets = [talentoSliderContainer, talentoSection].filter(Boolean);
  hoverTargets.forEach(target => {
    target.addEventListener('mouseenter', () => {
      isHovered = true;
      if (progressBar && currentSlideIndex !== VIDEO_INDEX) {
        progressBar.style.animationPlayState = 'paused';
      }
    });
    target.addEventListener('mouseleave', () => {
      isHovered = false;
      if (progressBar && currentSlideIndex !== VIDEO_INDEX) {
        progressBar.style.animationPlayState = 'running';
      }
    });
  });

  dotBtns.forEach(dot => {
    dot.addEventListener('click', (e) => {
      e.stopPropagation();
      const targetIndex = parseInt(dot.getAttribute('data-index'), 10);
      showSlide(targetIndex);
      if (targetIndex !== VIDEO_INDEX && isTalentoSectionVisible) {
        startSliderTimer();
      }
    });
  });

  // IntersectionObserver: Solo reproducir video y avanzar carrusel cuando la sección esté visible
  if (talentoSection && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        isTalentoSectionVisible = entry.isIntersecting && entry.intersectionRatio >= 0.25;

        if (isTalentoSectionVisible) {
          // Entró a la sección de talento
          if (currentSlideIndex === VIDEO_INDEX && videoEl) {
            setAudioState(false);
            const playPromise = videoEl.play();
            if (playPromise !== undefined) {
              playPromise.catch(() => {
                setAudioState(true);
                videoEl.play().catch(() => {});
              });
            }
          } else {
            startSliderTimer();
          }
        } else {
          // Salió de la sección de talento: Pausar inmediatamente video y silenciar
          stopSliderTimer();
          if (videoEl) {
            videoEl.pause();
            setAudioState(true);
          }
        }
      });
    }, { threshold: [0, 0.25, 0.5] });

    observer.observe(talentoSection);
  } else {
    // Fallback sin IntersectionObserver
    isTalentoSectionVisible = true;
    startSliderTimer();
  }

  showSlide(0);
}


